import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRouter from "../features/auth/components/ProtectedRouter";

import Layout             from "../shared/components/Layout";
import Login              from "../features/auth/pages/LoginPage";
import InvitacionPage     from "../features/auth/pages/InvitacionPage";
import RecuperarPage      from "../features/auth/pages/RecuperarPage";
import RestablecerPage    from "../features/auth/pages/RestablecerPage";
import Dashboard          from "../features/dashboard/pages/DashboardPage";
import AddResidentPage    from "../features/residents/pages/AddResidentPage";
import EditResidentPage   from "../features/residents/pages/EditResidentPage";
import ListResidents      from "../features/residents/pages/ListResidentPage";
import AddInvoices        from "../features/finance/invoices/pages/AddInvoices";
import ListInvoices       from "../features/finance/invoices/pages/ListInvoices";
import ListNotasCredito   from "../features/finance/invoices/pages/ListNotasCredito";
import ListNotasDebito    from "../features/finance/invoices/pages/ListNotasDebito";
import AddFacturaMasiva   from "../features/finance/invoices/pages/AddFacturaMasiva";
import ListReceipt        from "../features/finance/receipts/pages/ListReceipt";
import AddReceipt         from "../features/finance/receipts/pages/AddReceipt";
import ApplyReceipt       from "../features/finance/receipts/pages/ApplyReceipt";
import SettingsPage       from "../features/settings/pages/SettingsPage";
import ListCxC            from "../features/finance/cxc/pages/ListCxC";
import ListCatalogo       from "../features/finance/catalogo/pages/ListCatalogo";
import ListAsientos       from "../features/finance/asientos/pages/ListAsientos";
import AddAsiento         from "../features/finance/asientos/pages/AddAsiento";
import ConciliacionBancaria from "../features/finance/conciliacion/pages/ConciliacionBancaria";
import ListTraslados      from "../features/finance/traslados/pages/ListTraslados";
import AddTraslado        from "../features/finance/traslados/pages/AddTraslado";
import CuentasBancariasPage from "../features/finance/bancos/pages/CuentasBancariasPage";
import ListMovimientosBancarios from "../features/finance/bancos/pages/ListMovimientosBancarios";
import ListPrestamos      from "../features/finance/prestamos/pages/ListPrestamos";
import Presupuesto        from "../features/finance/presupuesto/pages/Presupuesto";
// CxP
import ListCxP            from "../features/finance/cxp/pages/ListCxP";
import ListFacturasCxP    from "../features/finance/cxp/pages/ListFacturasCxP";
import AddCxP             from "../features/finance/cxp/pages/AddCxP";
import AddReceiptCxP      from "../features/finance/cxp/pages/AddReceiptCxP";
import ApplyReceiptCxP    from "../features/finance/cxp/pages/ApplyReceiptCxP";
import ListReceiptCxP     from "../features/finance/cxp/pages/ListReceiptCxP";
import ListNotasCreditoCxP from "../features/finance/cxp/pages/ListNotasCreditoCxP";
import ListNotasDebitoCxP from "../features/finance/cxp/pages/ListNotasDebitoCxP";
// Estados financieros — página única con tabs
import EstadosFinancieros  from "../features/finance/reportes/pages/EstadosFinancieros";
import Informes            from "../features/finance/reportes/pages/Informes";
import ReporteRubros       from "../features/finance/reportes/pages/ReporteRubros";
import RegistroIngresos        from "../features/finance/registros/pages/RegistroIngresos";
import RegistroIngresosAgregar from "../features/finance/registros/pages/RegistroIngresosAgregar";
import RegistroGastos          from "../features/finance/registros/pages/RegistroGastos";
import RegistroGastosAgregar   from "../features/finance/registros/pages/RegistroGastosAgregar";
import AdminPage               from "../features/admin/pages/AdminPage";
import ListProveedoresPage     from "../features/proveedores/pages/ListProveedoresPage";
import AddProveedorPage       from "../features/proveedores/pages/AddProveedorPage";
import EditProveedorPage      from "../features/proveedores/pages/EditProveedorPage";
// Lecturas de Agua
import AguaCaptura            from "../features/agua/pages/AguaCaptura";
import AguaHistorial          from "../features/agua/pages/AguaHistorial";
import AguaResumen            from "../features/agua/pages/AguaResumen";
// Seguridad: la Garita (app del guarda, con su propio cascarón) y las
// pantallas de administración dentro de Corvana.
import GaritaShell            from "../features/seguridad/components/GaritaShell";
import GaritaBuscar           from "../features/seguridad/pages/GaritaBuscar";
import GaritaRegistrar        from "../features/seguridad/pages/GaritaRegistrar";
import GaritaAdentro          from "../features/seguridad/pages/GaritaAdentro";
import SeguridadBitacora      from "../features/seguridad/pages/SeguridadBitacora";
import SeguridadGuardas       from "../features/seguridad/pages/SeguridadGuardas";
// Portal Residentes
import PortalShell            from "../features/portal/components/PortalShell";
import PortalDashboard        from "../features/portal/pages/PortalDashboard";
import PortalReservaciones    from "../features/portal/pages/PortalReservaciones";
import PortalAvisosPago       from "../features/portal/pages/PortalAvisosPago";
import PortalAvisos           from "../features/portal/pages/PortalAvisos";
// Portal Admin
import AdminResidentes        from "../features/portal/pages/AdminResidentes";
import AdminAreas             from "../features/portal/pages/AdminAreas";
import AdminReservaciones     from "../features/portal/pages/AdminReservaciones";
import AdminAvisosPago        from "../features/portal/pages/AdminAvisosPago";
import AdminAvisos            from "../features/portal/pages/AdminAvisos";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* Públicas: se llega desde un link del correo, sin sesión */}
        <Route path="/invitacion/:token" element={<InvitacionPage />} />
        <Route path="/recuperar" element={<RecuperarPage />} />
        <Route path="/restablecer/:uid/:token" element={<RestablecerPage />} />
        {/* ── Garita: pantalla completa para celular/tablet, sin menú lateral ── */}
        <Route element={<ProtectedRouter><GaritaShell /></ProtectedRouter>}>
          <Route path="/garita"                              element={<GaritaBuscar />} />
          <Route path="/garita/registrar"                    element={<GaritaRegistrar />} />
          <Route path="/garita/adentro"                      element={<GaritaAdentro />} />
          {/* Direcciones viejas o mal escritas (ej. /garita/turno): a Buscar */}
          <Route path="/garita/*"                            element={<Navigate to="/garita" replace />} />
        </Route>
        <Route element={<ProtectedRouter><Layout /></ProtectedRouter>}>
          <Route path="/"                                    element={<Dashboard />} />
          <Route path="/residentes"                          element={<ListResidents />} />
          <Route path="/residentes/agregar"                  element={<AddResidentPage />} />
          <Route path="/residentes/editar/:filialId"         element={<EditResidentPage />} />
          <Route path="/proveedores"                         element={<ListProveedoresPage />} />
          <Route path="/proveedores/agregar"                 element={<AddProveedorPage />} />
          <Route path="/proveedores/editar/:id"              element={<EditProveedorPage />} />
          <Route path="/finanzas/facturas"                   element={<ListInvoices />} />
          <Route path="/finanzas/facturas/agregar"           element={<AddInvoices />} />
          <Route path="/finanzas/facturas/masivo"            element={<AddFacturaMasiva />} />
          <Route path="/finanzas/recibos"                    element={<ListReceipt />} />
          <Route path="/finanzas/recibos/agregar"            element={<AddReceipt />} />
          <Route path="/finanzas/recibos/:reciboId/aplicar"  element={<ApplyReceipt />} />
          <Route path="/finanzas/notas-credito"              element={<ListNotasCredito />} />
          <Route path="/finanzas/notas-debito"               element={<ListNotasDebito />} />
          <Route path="/finanzas/cxc"                        element={<ListCxC />} />
          <Route path="/finanzas/catalogo"                   element={<ListCatalogo />} />
          <Route path="/finanzas/asientos"                   element={<ListAsientos />} />
          <Route path="/finanzas/asientos/nuevo"             element={<AddAsiento />} />
          <Route path="/finanzas/bancos/cuentas"              element={<CuentasBancariasPage />} />
          <Route path="/finanzas/bancos/movimientos"          element={<ListMovimientosBancarios />} />
          <Route path="/finanzas/conciliacion"               element={<ConciliacionBancaria />} />
          <Route path="/finanzas/traslados"                  element={<ListTraslados />} />
          <Route path="/finanzas/prestamos"                  element={<ListPrestamos />} />
          <Route path="/finanzas/presupuesto"                element={<Presupuesto />} />
          <Route path="/finanzas/traslados/nuevo"            element={<AddTraslado />} />
          <Route path="/finanzas/traslados/:id/editar"       element={<AddTraslado />} />
          {/* CxP */}
          <Route path="/finanzas/cxp"                        element={<ListCxP />} />
          <Route path="/finanzas/cxp/facturas"               element={<ListFacturasCxP />} />
          <Route path="/finanzas/cxp/facturas/agregar"       element={<AddCxP />} />
          <Route path="/finanzas/cxp/recibos"                element={<ListReceiptCxP />} />
          <Route path="/finanzas/cxp/recibos/agregar"        element={<AddReceiptCxP />} />
          <Route path="/finanzas/cxp/recibos/:reciboId/aplicar" element={<ApplyReceiptCxP />} />
          <Route path="/finanzas/cxp/notas-credito"          element={<ListNotasCreditoCxP />} />
          <Route path="/finanzas/cxp/notas-debito"           element={<ListNotasDebitoCxP />} />
          {/* Registros */}
          <Route path="/finanzas/ingresos"       element={<RegistroIngresos />} />
          <Route path="/finanzas/ingresos/nuevo"  element={<RegistroIngresosAgregar />} />
          <Route path="/finanzas/gastos"          element={<RegistroGastos />} />
          <Route path="/finanzas/gastos/nuevo"    element={<RegistroGastosAgregar />} />
          {/* Informes analíticos CxC/CxP (gráficas + filtros) */}
          <Route path="/finanzas/informes"                   element={<Informes />} />
          {/* Matriz filial × rubro (facturado / cobrado / pendiente) */}
          <Route path="/finanzas/rubros"                     element={<ReporteRubros />} />
          {/* Estados Financieros — página única con tabs (?tab=XXXX) */}
          <Route path="/finanzas/estados"                    element={<EstadosFinancieros />} />
          {/* Rutas legacy — redirigen al tab correspondiente */}
          <Route path="/finanzas/balance-comprobacion"       element={<EstadosFinancieros />} />
          <Route path="/finanzas/estado-resultados"          element={<EstadosFinancieros />} />
          <Route path="/finanzas/balance-general"            element={<EstadosFinancieros />} />
          <Route path="/finanzas/estado-financiero"          element={<EstadosFinancieros />} />
          {/* ── Lecturas de Agua ── */}
          <Route path="/agua"                                element={<AguaCaptura />} />
          <Route path="/agua/historial"                      element={<AguaHistorial />} />
          <Route path="/agua/resumen"                        element={<AguaResumen />} />
          {/* ── Seguridad (administración) ── */}
          <Route path="/seguridad/bitacora"                  element={<SeguridadBitacora />} />
          <Route path="/seguridad/guardas"                   element={<SeguridadGuardas />} />
          <Route path="/settings"                            element={<SettingsPage />} />
          <Route path="/admin"                               element={<AdminPage />} />
          {/* ── Portal Residentes (RESIDENTE) — PortalShell activa el polling de notificaciones ── */}
          <Route element={<PortalShell />}>
            <Route path="/portal"                            element={<PortalDashboard />} />
            <Route path="/portal/reservaciones"              element={<PortalReservaciones />} />
            <Route path="/portal/avisos-pago"                element={<PortalAvisosPago />} />
            <Route path="/portal/avisos"                     element={<PortalAvisos />} />
          </Route>
          {/* ── Portal Admin (USUARIO/CONTADOR) ── */}
          <Route path="/portal/admin/residentes"             element={<AdminResidentes />} />
          <Route path="/portal/admin/areas"                  element={<AdminAreas />} />
          <Route path="/portal/admin/reservaciones"          element={<AdminReservaciones />} />
          <Route path="/portal/admin/avisos-pago"            element={<AdminAvisosPago />} />
          <Route path="/portal/admin/avisos"                 element={<AdminAvisos />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
